const $ = jQuery.noConflict();

class MobileHeader {
	constructor(
		trigger = '.c-btn-hamburger',
		pbody = 'body',
		listParent = '.menu-item-has-children > a',
		ctas = '.main-header__right'
	) {
		this.trigger = trigger;
		this.pbody = pbody;
		this.listParent = listParent;
		this.ctas = ctas;
		this.ctasClone = $(this.ctas).clone();
	}
	init() {
		$(this.trigger).on('click', this.setNavState);
		$(this.listParent).on('click', this.setListState);

		// Clone CTAs for easier responsive styling
		// this.ctasClone = $(this.ctas).clone();
		this.ctasClone.removeClass('main-header__right');
		this.ctasClone.addClass('main-header__nav-ctas');
		$('.main-header__left').append(this.ctasClone);
	}
	setNavState(e) {
		e.preventDefault();
		const body = $('body');

		if ($(this).hasClass('open')) {
			MobileHeader.hideWrapper(this, body);
		} else {
			MobileHeader.showWrapper(this, body);
		}
	}
	setListState(e) {
		e.preventDefault();
		if (!$(this).hasClass('open')) {
			$(this).addClass('open');
		} else {
			$(this).removeClass('open');
		}
	}
	static hideWrapper(el, body) {
		$(el).removeClass('open');
		body.removeClass('overlayed');
		$(el).next().removeClass('active');
	}
	static showWrapper(el, body) {
		$(el).addClass('open');
		body.addClass('overlayed');
		$(el).next().addClass('active');
	}
	resized() {
		if (
			!$(this.trigger).is(':visible') &&
			$(this.trigger).hasClass('open')
		) {
			MobileHeader.hideWrapper(this.trigger, $(this.pbody));
		}
	}
	hideOutsideClick(e) {
		if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
			const container = $('.main-header');
			if (
				!container.is(e.target) &&
				container.has(e.target).length === 0
			) {
				MobileHeader.hideWrapper(this.trigger, $(this.pbody));
			}
		}
	}
}

export default MobileHeader;
